import * as colors from '@mui/material/colors';

export const darkPalette = {
  background: {
    default: 'hsl(220, 15%, 8%)',
    paper: 'hsl(220, 15%, 12%)',
  },
  font: {
    primary: 'hsl(210, 20%, 95%)',
    secondary: 'hsl(215, 15%, 55%)',
    disabled: 'hsl(215, 15%, 55%)',
    hint: 'hsl(215, 15%, 65%)',
  },
  text: {
    primary: 'hsl(210, 20%, 95%)',
    secondary: 'hsl(215, 15%, 55%)',
    disabled: 'hsl(215, 15%, 55%)',
  },
  action: {
    disabled: 'hsl(210, 16%, 72%)',
    disabledBackground: 'hsl(220, 12%, 28%)',
  },
  primary: {
    main: 'hsl(24, 100%, 55%)',
    dark: 'hsl(24, 100%, 50%)',
    light: 'hsl(24, 100%, 60%)',
    contrastText: 'hsl(0, 0%, 100%)',
  },
  secondary: {
    main: 'hsl(220, 15%, 18%)',
    dark: 'hsl(220, 15%, 20%)',
    light: 'hsl(220, 15%, 15%)',
    contrastText: 'hsl(210, 20%, 85%)',
  },
  error: {
    main: 'hsl(0, 75%, 55%)',
    dark: '#e54d4d',
    light: '#ff6b6b',
    contrastText: '#ffffff',
  },
  input: {
    main: 'hsl(220, 15%, 12%)',
    dark: 'hsl(220, 15%, 18%)',
    contrastText: 'hsl(210, 20%, 95%)',
    placeholderText: 'hsl(215, 15%, 55%)',
    disabled: 'hsl(220, 15%, 20%)',
  },
  border: {
    main: 'hsl(220, 15%, 18%)',
  },
  header: {
    main: 'hsl(220, 15%, 12%)',
    contrastText: 'hsl(210, 20%, 95%)',
  },
  containerHeader: {
    main: 'hsl(220, 15%, 12%)',
    contrastText: 'hsl(210, 20%, 95%)',
  },
  menu: {
    primary: 'hsl(220, 15%, 12%)',
    primaryDark: 'hsl(220, 15%, 15%)',
    secondary: 'rgba(255, 102, 0, 0.2)',
    secondaryDark: 'rgba(255, 102, 0, 0.4)',
    contrastText: 'hsl(215, 15%, 55%)',
    contrastTextDark: 'hsl(210, 20%, 95%)',
    divider: 'hsl(220, 15%, 18%)',
    secondaryContrastText: 'hsl(24, 100%, 55%)',
  },
  tabControl: {
    backgroundColor: 'hsl(220, 15%, 18%)',
    primary: 'hsl(220, 15%, 12%)',
    primaryDark: 'hsl(220, 15%, 20%)',
    secondary: 'hsl(24, 100%, 55%)',
    secondaryDark: 'hsl(24, 100%, 60%)',
    contrastText: 'hsl(215, 15%, 55%)',
    contrastTextDark: 'hsl(210, 20%, 95%)',
    secondaryContrastText: 'hsl(0, 0%, 100%)',
  },
  contentBackground: {
    grey: 'hsl(220, 15%, 15%)',
  },
  paper: {
    backgroundColor: 'hsl(220, 15%, 12%)',
    hoverBackgroundColor: 'hsl(220, 15%, 15%)',
    borderColor: 'hsl(220, 15%, 18%)',
    hoverBorderColor: 'hsl(24, 100%, 55%)',
  },
  warning: {
    main: 'hsl(45, 100%, 50%)',
  },
  info: {
    main: '#fcb23b',
  },
  success: {
    main: 'hsl(142, 70%, 45%)',
    dark: '#49ad8b',
    light: '#67c9a0',
    contrastText: '#ffffff',
  },
  custom: {
    red: 'hsl(0, 75%, 55%)',
    white: 'hsl(210, 20%, 95%)',
    green: '#8abb2a',
    black: '#000000',
    linkColor: 'hsl(24, 100%, 55%)',
  },
  shadow: 'rgba(214, 207, 194, 0.06)',
  footer: {
    color: 'hsl(215, 15%, 55%)',
    activeColor: 'hsl(24, 100%, 55%)',
    backgroundActiveColor: 'rgba(255, 102, 0, 0.25)',
  },
  exerciseStatus: {
    started: 'rgba(17, 75, 194, 0.4)',
    notStartedOddLine: 'transparent',
    notStartedEvenLine: 'transparent',
    doLateOddLine:
      'linear-gradient(90deg, rgba(252, 178, 59, 0.25), transparent)',
    doLateEvenLine:
      'linear-gradient(90deg, rgba(252, 178, 59, 0.25), transparent)',
    skippedOddLine:
      'linear-gradient(90deg, rgba(204, 49, 10, 0.25), transparent)',
    skippedEvenLine:
      'linear-gradient(90deg, rgba(204, 49, 10, 0.25), transparent)',
    finishedOddLine:
      'linear-gradient(90deg, hsla(142 70% 45% / .2), transparent)',
    finishedEvenLine:
      'linear-gradient(90deg, hsla(142 70% 45% / .2), transparent)',
  },
  primaryTransparent: 'rgba(255, 102, 0, 0.2)',
  primaryGradient:
    'linear-gradient(135deg, hsl(24, 100%, 55%), hsl(24, 100%, 65%))',
  successGradient:
    'linear-gradient(135deg, rgb(31, 173, 83), rgb(27, 152, 110))',
  disabled: 'hsl(220, 15%, 20%)',
  primarySamitransparent: 'hsla(24, 100%, 55%, 0.2)',
  successSamitransparent: 'hsla(142, 70%, 45%, 0.2)',
  warningSamitransparent: 'hsla(45, 100%, 50%, 0.2)',
  errorSamitransparent: 'hsla(0, 75%, 55%, 0.2)',
  ...colors,
} as const;
